/* import __COLOCATED_TEMPLATE__ from './about-link-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();